<script setup>
import { CellGroup, RadioGroup, Radio, Button, Form, Field } from 'vant'
import { onMounted, reactive, ref, watch } from 'vue'
import { Toast } from 'vant'

const props = defineProps({
  modelValue: Boolean,
  activity: undefined,
})

const emit = defineEmits(['update:modelValue', 'onFormSumbit'])

const handleCloseClick = () => {
  emit('update:modelValue', false)
}

// 填写领奖信息
const handleFormClick = () => {
  emit('onFormSumbit', formData)
  handleCloseClick()
}

const getNeedFormItem = (activity) => {
  let list = []
  // 姓名msgNameType 性别msgSexType 年龄msgAgeType
  // 地址msgAddressType 学号 msgStuType 收货人msgGoods
  // 收货地址msgGoodsAdress 备注msgRemarkType
  // 电话msgPhone 身份证msgIdCardType
  let attr = [
    'msgNameType',
    'msgSexType',
    'msgAgeType',
    'msgAddressType',
    'msgStuType',
    'msgGoods',
    'msgGoodsAdress',
    'msgRemarkType',
    'msgPhone',
    'msgIdCardType',
  ]
  attr.map((item) => {
    // console.log(item)
    // console.log(1111111,activity && activity[item] && activity[item] === 1)
    if (activity && activity[item] && activity[item] === 1) list.push(item)
  })
  return list
}
const fromRef = ref(null)
const onFailed = (errorInfo) => {
  const { errors } = errorInfo
  if (errors.length) {
    Toast({ message: errors[0].message, teleport: fromRef })
  }
}

const hasItem = (attr) => {
  let list = getNeedFormItem(props.activity)
  return list.includes(attr)
}

const formData = reactive({
  name: '',
  sex: '1',
  age: '',
  phone: '',
  address: '',
  studentId: '',
  idCard: '',
  receiver: '',
  shippingAddress: '',
  remark: '',
})

const resetState = () => {
  Object.assign(formData, getInitalState())
}

onMounted(() => {
  resetState
  console.log('1234123413421342')
})

const rules = {
  name: [{ required: true, message: '请输入姓名' }],
  sex: [{ required: true, message: '请选择性别' }],
  age: [{ required: true, message: '请输入年龄' }],
  address: [{ required: true, message: '请输入地址' }],
  studentId: [{ required: true, message: '请输入学号' }],
  receiver: [{ required: true, message: '请输入收货人' }],
  shippingAddress: [{ required: true, message: '请输入收货地址' }],
  remark: [{ required: true, message: '请输入备注' }],
  phone: [
    {
      required: true,
      message: '请填写手机号',
    },
    {
      validator: (value) => {
        return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
          value
        )
      },
      message: '手机号格式错误',
    },
  ],
  idCard: [
    { required: true, message: '请填写身份证号' },
    {
      validator: (value) => {
        const card15 =
          /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/
        const card18 =
          /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        return card15.test(value) || card18.test(value)
      },
      message: '身份证号码格式错误',
    },
  ],
}
</script>
<template>
  <div v-if="modelValue">
    <div class="form-toast fade-in" ref="fromRef">
      <img
        @click="handleCloseClick"
        class="close-btn"
        src="../../../assets/img/person/close.png"
        alt=""
      />
      <h2 class="success-title">请填写中奖信息</h2>
      <!--      <van-config-provider
        :theme-vars="{
          cellGroupInsetPadding: 0,
          fieldLabelMarginRight: 10,
          cellVerticalPadding: '7px'
        }"
      >-->
      <Form
        @submit="handleFormClick"
        @failed="onFailed"
        class="form-content"
        label-align="right"
        label-width="85px"
        :show-error="true"
        :show-error-message="false"
      >
        <div class="scroll-content">
          <CellGroup inset v-if="hasItem('msgNameType')">
            <Field
              v-model="formData.name"
              class="form_item"
              label="姓名："
              placeholder="请输入姓名"
              :rules="rules.name"
            />
          </CellGroup>
          <CellGroup inset v-if="hasItem('msgSexType')">
            <Field class="form_item not" label="性别：" :rules="rules.sex">
              <template #input>
                <RadioGroup
                  v-model="formData.sex"
                  direction="horizontal"
                  icon-size="16px"
                >
                  <Radio name="1">男</Radio>
                  <Radio name="0">女</Radio>
                </RadioGroup>
              </template>
            </Field>
          </CellGroup>
          <CellGroup inset v-if="hasItem('msgAgeType')">
            <Field
              v-model="formData.age"
              type="digit"
              class="form_item"
              label="年龄："
              placeholder="请输入年龄"
              :rules="rules.age"
            />
          </CellGroup>
          <CellGroup inset v-if="hasItem('msgPhone')">
            <Field
              v-model="formData.phone"
              type="tel"
              class="form_item"
              label="手机号："
              placeholder="请输入手机号"
              :rules="rules.phone"
            />
          </CellGroup>
          <CellGroup inset v-if="hasItem('msgAddressType')">
            <Field
              v-model="formData.address"
              class="form_item no-scroll"
              label="地址："
              rows="1"
              autosize
              type="textarea"
              placeholder="请输入地址"
              :rules="rules.address"
            />
          </CellGroup>
          <CellGroup inset v-if="hasItem('msgStuType')">
            <Field
              v-model="formData.studentId"
              class="form_item"
              label="学号："
              placeholder="请输入学号"
              :rules="rules.studentId"
            />
          </CellGroup>
          <CellGroup inset v-if="hasItem('msgIdCardType')">
            <Field
              v-model="formData.idCard"
              class="form_item"
              label="身份证："
              placeholder="请输入身份证"
              :rules="rules.idCard"
            />
          </CellGroup>
          <CellGroup inset v-if="hasItem('msgGoods')">
            <Field
              v-model="formData.receiver"
              class="form_item"
              label="收货人："
              placeholder="请输入收货人"
              :rules="rules.receiver"
            />
          </CellGroup>
          <CellGroup inset v-if="hasItem('msgGoodsAdress')">
            <Field
              v-model="formData.shippingAddress"
              class="form_item no-scroll"
              label="地址："
              rows="1"
              autosize
              type="textarea"
              placeholder="请输入收货地址"
              :rules="rules.shippingAddress"
            />
          </CellGroup>
          <CellGroup inset v-if="hasItem('msgRemarkType')">
            <Field
              v-model="formData.remark"
              class="form_item no-scroll"
              label="备注："
              rows="1"
              autosize
              type="textarea"
              placeholder="请输入备注"
            />
          </CellGroup>
        </div>
        <Button class="submit-btn" native-type="submit"> 立即领取 </Button>
        <p class="tips">提交领奖信息后才能获得奖品</p>
      </Form>
      <!--      </van-config-provider>-->
    </div>
    <div class="mask"></div>
  </div>
</template>

<style>
.van-field__label {
  font-size: 0.55rem;
  letter-spacing: 4px;
  color: #555555;
  text-shadow: 0px 0px 5px rgba(159, 30, 25, 0.1);
  height: 0.8rem;
  line-height: 0.8rem;
}

.van-field__value {
  background: #f2f2f275;
  border-radius: 10px;
  padding: 0 15px;
  line-height: 0.8rem;
}
</style>

<style lang="scss" scoped>
@import '../../../assets/css/animate';

.form-toast {
  position: fixed;
  top: 22%;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2080;
  margin: 0 auto;
  width: 600px;
  height: 760px;
  background: #ffffff;
  border-radius: 10px;

  .close-btn {
    position: absolute;
    padding: 16px;
    top: 0;
    right: 0;
    width: 34px;
    height: 34px;
  }

  .success-title {
    position: absolute;
    top: 56px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 327px;
    height: 43px;
    font-size: 44px;
    color: #f85a61;
    text-align: center;
  }

  .tips {
    margin: 0;
    margin-top: 20px;
    text-align: center;
    font-weight: 400;
    color: #999999;
    font-size: 24px;
  }

  .submit-btn {
    display: block;
    margin: 0 auto;
    margin-top: 40px;
    width: 309px;
    height: 86px;
    font-size: 36px;
    color: #ffffff;
    background: linear-gradient(-26deg, #f85d83, #f94659);
    border: 3px solid #f9c642;
    box-shadow: 0px 0px 15px 0px rgba(159, 30, 25, 0.2);
    border-radius: 42px;
  }

  .form-content {
    margin-top: 140px;

    .form_item {
      //:deep(.van-field__label) {
      //  font-size: 32px;
      //  letter-spacing: 4px;
      //  color: #555555;
      //  text-shadow: 0px 0px 5px rgba(159, 30, 25, 0.1);
      //  height: 60px;
      //  line-height: 60px;
      //}

      //:deep(.van-field__value) {
      //  background: #f2f2f275;
      //  border-radius: 10px;
      //  padding: 0 15px;
      //  line-height: 60px;
      //}
    }

    .not {
      :deep(.van-field__value) {
        background: transparent;
      }
    }

    :deep(.van-radio-group--horizontal) {
      margin: 0;
    }

    ::-webkit-input-placeholder {
      font-size: 24px;
      color: #99999990;
    }

    /* Firefox 4-18 */
    :-moz-placeholder {
      font-size: 24px;
      color: #99999990;
    }

    /* Firefox 19-50 */
    ::-moz-placeholder {
      font-size: 24px;
      color: #99999990;
    }

    /* Edge (also supports ::-webkit-input-placeholder) */
    ::-ms-input-placeholder {
      font-size: 24px;
      color: #99999990;
    }

    /* CSS Working Draft */
    ::placeholder {
      font-size: 24px;
      color: #99999990;
    }

    :deep(.van-field__control--error),
    :deep(.van-field__control--error::placeholder) {
      color: var(--van-field-input-error-text-color);
      -webkit-text-fill-color: currentColor;
    }
  }
  .no-scroll ::-webkit-scrollbar {
    display: none;
    width: 0;
  }

  .scroll-content {
    height: 410px;
    margin-right: 10px;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
}

.mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba($color: #000000, $alpha: 0.6);
  z-index: 2077;
}

.scroll-content::-webkit-scrollbar-track-piece {
  background-color: rgba(0, 0, 0, 0);
  border-left: 1px solid rgba(0, 0, 0, 0);
}
.scroll-content::-webkit-scrollbar {
  width: 8px;
  height: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
.scroll-content::-webkit-scrollbar-thumb {
  background-color: rgba(191, 191, 191, 191);
  background-clip: padding-box;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  min-height: 28px;
}
.scroll-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
</style>
